export const UploaderStatus: Object<string, string> = {
	STARTED: 0,
	STOPPED: 1,
};
